import { render, staticRenderFns } from "./WhitelabelSize.vue?vue&type=template&id=1c214bd6&scoped=true&"
import script from "./WhitelabelSize.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelSize.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelSize.vue?vue&type=style&index=0&id=1c214bd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c214bd6",
  null
  
)

export default component.exports